export const iconFontAwesomeShapesStar = (
	<i className="fa-solid fa-star"></i>
);
